import React from "react"
import BrakeImage from  "./images/brakeImage"

const ServicePromo = () => (
    <section className="jl-more">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-4 col-md-12">                                       
                    <div><h2 className="header">We're more than just an oil change</h2></div>
                    <p>While Jiffy Lube pioneered the fast lube industry over 40 years ago, we do more than change oil. Jiffy Lube offers expanded services that customers want and need – including tires, brakes and spark plug replacement.</p>
                </div>
                <div className="col-lg-7 offset-lg-1 col-md-12">
                    <div className="brake-image">
                        <BrakeImage/>
                    </div>
                </div>
            </div>
        </div>
    </section>
)

export default ServicePromo